<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">Subscriptions</h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-5">
                <div class="row vertical-align-center">
                  <div class="dataTables_length col-sm-4">
                    <label>Show
                      <select class="form-control input-sm" v-on:change="onPageSizeChange">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select> entries
                    </label>
                  </div>
                  <button type="button" v-on:click="showSubscriptionDialog()" class="btn btn-primary new-btn col-sm-offset-1 col-sm-3">New
                    subscription
                  </button>
                </div>
              </div>

              <div class="col-sm-6">
                <div id="search_filter" class="dataTables_filter">
                  <input type="search" class="form-control input-sm" v-model="query">
                  <button type="submit" class="btn btn-flat btn-primary search-btn" v-on:click="search">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 table-responsive">
                <table role="grid" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th v-on:click="sortBy('name','true')" v-bind:class="{ active: sortField === 'name' }" class="sorting_asc" colspan="1" rowspan="1"
                        tabindex="0">Name
                    </th>
                    <th colspan="1" rowspan="1" tabindex="0">Subscribers</th>
                    <th v-on:click="sortBy('frequency','true')" v-bind:class="{ active: sortField === 'frequency' }" class="sorting_asc" colspan="1"
                        rowspan="1" tabindex="0">Frequency
                    </th>
                    <th colspan="1" rowspan="1" tabindex="0">Area</th>
                    <th v-on:click="sortBy('creationDate','true')" v-bind:class="{ active: sortField === 'creationDate' }" class="sorting_asc"
                        colspan="1" rowspan="1" tabindex="0">Subscription date
                    </th>
                    <th></th>
                  </tr>
                  </thead>
                  <div v-if="!subscriptions.length" class="no-data">No data found</div>
                  <tbody v-else>
                  <tr class="even clickable" role="row" v-for="subscription in subscriptions" @click="showSubscriptionDialog(subscription)">
                    <td class="sorting_1">{{ subscription.name }}</td>
                    <td>{{ subscription.emails.join(', ') }}</td>
                    <td>{{ subscription.frequency }}</td>
                    <td>{{ subscription.zone }}</td>
                    <td>{{ subscription.creationDate | prettyDateTime }}</td>
                    <td class="row-actions">
                      <i class="far fa-edit" title="Edit"></i>
                      <i class="far fa-trash-alt" title="Delete" @click.stop="deleteSubscription(subscription._id)"></i>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row" v-if="subscriptions.length">
              <div class="align-infos col-sm-12">
                <div class="dataTables_info" role="status" aria-live="polite">
                  Showing {{ total - subscriptions.length + 1 > (page + 1) * size - 1 ? (page + 1) * size - 1 : total - subscriptions.length + 1 }}
                  to {{total > (page + 1) * size ? (page + 1) * size:total}} of {{total}} entries
                </div>
              </div>
              <div class="table-pagination col-sm-12">
                <paginate
                  :page-count="pageTotal"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="onPageChange"
                  :prev-text="'Prev'"
                  :force-page="page"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'">
                </paginate>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <new-subscription-modal ref="subscription-modal" id="new-subscription-modal" @remove="deleteSubscription" @close="closeModal"></new-subscription-modal>
  </section>
</template>

<script>
  import _ from 'lodash'
  import 'datatables.net'
  import 'datatables.net-bs'

  import api from '../../api'

  export default {
    name: 'Subscriptions',
    data () {
      return {
        subscriptions: [],
        selectedSubscription: null,
        size: 10,
        page: 0,
        total: 0,
        pageTotal: 0,
        sortField: 'name',
        desc: 'true',
        query: null
      }
    },
    methods: {
      onPageSizeChange (event) {
        this.size = event.target.value
        this.refresh(true)
      },
      onPageChange (pageNum) {
        this.page = pageNum - 1
        this.refresh()
      },
      sortBy (sortField, desc) {
        this.sortField = sortField
        this.desc = desc
        this.refresh(true)
      },
      refresh (toFirstPage = false) {
        this.search(toFirstPage)
      },
      search (toFirstPage = true) {
        if (toFirstPage) {
          this.page = 0
        }

        let endpoint = `/notifications?size=${this.size}&page=${this.page}&sortField=${this.sortField}&desc=${this.desc}`
        if (!_.isNil(this.query) && !_.isEmpty(this.query)) {
          endpoint += `&q=${this.query}`
        }

        api.authenticatedRequest('GET', endpoint)
          .then(response => {
            this.subscriptions = response.data
            this.total = response.data.length
            this.pageTotal = Math.ceil(this.total / this.size)
            /*
            const data = response.data
            this.subscriptions = data.data
            this.total = data.total
            this.pageTotal = Math.ceil(this.total / this.size)
            */
          })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      },
      showSubscriptionDialog (subscription) {
        this.selectedSubscription = subscription
        window.jQuery('#new-subscription-modal').modal('show')
      },
      deleteSubscription (subscriptionId) {
        api.authenticatedRequest('DELETE', `/notifications/${subscriptionId}`)
          .then(() => {
            this.closeModal()
            this.refresh(true)
          })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      },
      closeModal () {
        window.jQuery('#new-subscription-modal').modal('hide')
      }
    },
    mounted () {
      this.$nextTick(() => {
        const that = this
        this.refresh(true)

        window.jQuery('#new-subscription-modal').modal({show: false})
          .on('show.bs.modal', function () {
            that.$refs['subscription-modal'].init(that.selectedSubscription)
          })
          .on('shown.bs.modal', function () {
            // Map should only be (re)initialized when fully visible so waiting for whole animation ending
            that.$refs['subscription-modal'].initMap()
          })
          .on('hidden.bs.modal', function () {
            that.refresh(true)
          })
      })
    }
  }
</script>

<style>
  @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

  table.dataTable thead .sorting:after,
  table.dataTable thead .sorting_asc:after,
  table.dataTable thead .sorting_desc:after {
    font-family: 'Font Awesome 5 Free';
  }

  .clickable {
    cursor: pointer;
  }

  table.dataTable thead .active:after {
    opacity: 0.5 !important;
  }

  table.dataTable thead .sorting:after {
    content: "\f0dc";
    opacity: 0.2;
  }

  table.dataTable thead .sorting_asc:after {
    content: "\f0dd";
    opacity: 0.2;
  }

  table.dataTable thead .sorting_desc:after {
    content: "\f0de";
    opacity: 0.2;
  }

  .row-actions {
    display: flex;
    justify-content: space-evenly;
  }

  .row-actions > i:hover {
    color: #666;
  }

  .row-actions > i.fa-trash-alt:hover {
    color: #b90000;
  }
</style>



// WEBPACK FOOTER //
// Subscriptions.vue?7f9afd75